export default __webpack_public_path__ + "static/media/cloudBack.e4d795dc.svg";